import type { HazardPoolZone } from "../systems/HazardPool.ts";
import { ELEMENT_COLORS } from "./designTokens.ts";

export class HazardPoolRenderer {
  constructor(
    private ctx: CanvasRenderingContext2D,
    private cellSize: number,
  ) {}

  render(pools: readonly HazardPoolZone[], frameTime: number): void {
    for (const pool of pools) {
      const lifeFrac = Math.max(
        0,
        pool.remaining / pool.profile.hazardPoolDuration,
      );
      const pulse = 0.5 + Math.sin(frameTime * 6 + pool.x * 0.03) * 0.1;
      const radius = pool.profile.zoneRadius;

      this.ctx.save();

      this.ctx.globalAlpha = (0.2 + pulse * 0.15) * lifeFrac;
      this.ctx.fillStyle = ELEMENT_COLORS.virus;
      this.ctx.beginPath();
      this.ctx.arc(pool.x, pool.y, radius, 0, Math.PI * 2);
      this.ctx.fill();

      this.ctx.globalAlpha = (0.25 + pulse * 0.2) * lifeFrac;
      this.ctx.strokeStyle = "#8A2BE2";
      this.ctx.lineWidth = Math.max(1, this.cellSize * 0.03);
      this.ctx.beginPath();
      this.ctx.arc(
        pool.x,
        pool.y,
        radius * (0.88 + pulse * 0.05),
        0,
        Math.PI * 2,
      );
      this.ctx.stroke();

      this.ctx.restore();
    }
  }
}
